import { ReleaseNotesService } from "../../sdServices/release-notes-config/release-notes-service";
import { ReleaseNotesByAppId } from "../../sdServices/release-notes-config/release-notes-config";

export class SdReleaseNoteSplashContentContoller {
  public releaseNotes: ReleaseNotesByAppId;
  public date: Date;
  public hasViewDetail: boolean;
  public viewDetailedCallback: Function;
  public ifRollback: boolean;

  public readonly DATE_FORMAT: Intl.DateTimeFormatOptions = { month: "long", day: "numeric", year: "numeric" };
  // @ngInject
  constructor(private releaseNotesService: ReleaseNotesService) {
    //
  }

  public getAppGlyphClass(appId: string): string {
    return this.releaseNotesService.getGlyphFromAppId(appId);
  }
}

export const sdReleaseNoteSplashContent: ng.IComponentOptions = {
  controller: SdReleaseNoteSplashContentContoller,
  bindings: {
    releaseNotes: "<",
    date: "<",
    hasViewDetail: "<",
    viewDetailed: "&",
    ifRollback: "<"
  },
  templateUrl: "../ServiceDesk/releaseNotes/splash/sd-release-note-splash-content.html"
};
